"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Adaptiv = function (props) {
    var Small = props.small, Long = props.long, height = props.height, width = props.width, fill = props.fill, stroke = props.stroke, _a = props.contrast, contrast = _a === void 0 ? '#fff' : _a, children = props.children, _b = props.shift, shift = _b === void 0 ? 0 : _b, title = props.title, _c = props.cutoffRadius, cutoffRadius = _c === void 0 ? 57 : _c, _d = props.minRadius, minRadius = _d === void 0 ? 20 : _d, _e = props.innerScale, innerScale = _e === void 0 ? 1 : _e, background = props.background, _f = props.max, max = _f === void 0 ? Long ? 70 : 45 : _f, rest = __rest(props, ["small", "long", "height", "width", "fill", "stroke", "contrast", "children", "shift", "title", "cutoffRadius", "minRadius", "innerScale", "background", "max"]);
    var Logo = Long || Small;
    var retract = 0;
    var maxRadius = max;
    var radius = maxRadius;
    var defaultWidth = 100;
    var defaultHeight = 100;
    if (typeof width === 'number' && typeof height === 'number') {
        defaultWidth = width;
        defaultHeight = height;
        radius = width / 2;
    }
    else if (typeof width === 'number') {
        radius = width / 2;
        defaultWidth = width;
        defaultHeight = width;
    }
    else if (typeof height === 'number') {
        radius = height / 2;
        defaultWidth = height;
        defaultHeight = height;
    }
    if (radius < minRadius) {
        return (react_1.default.createElement(Small, __assign({ width: width, height: height, fill: fill, stroke: stroke, title: title }, rest)));
    }
    if (radius > maxRadius) {
        var showChildren = children && radius > cutoffRadius;
        var offset = Long ? 40 : maxRadius + 10;
        if (showChildren) {
            maxRadius = max || (Long ? 70 : 40);
            if (radius - maxRadius < 25) {
                retract = Long ? 0 : radius - maxRadius;
            }
        }
        return (react_1.default.createElement("svg", __assign({ width: defaultWidth, height: defaultHeight, viewBox: "0 0 " + defaultWidth + " " + defaultHeight, fill: "none", version: "1.1" }, rest),
            title && react_1.default.createElement("title", null, title),
            background ? (react_1.default.createElement("rect", { width: defaultWidth, height: defaultHeight, fill: fill, stroke: stroke })) : (react_1.default.createElement("circle", { cx: radius, cy: radius, r: radius, fill: fill, stroke: stroke })),
            react_1.default.createElement("g", { transform: "translate(" + (defaultWidth / 2 - maxRadius * innerScale) + "," + (defaultHeight / 2 - maxRadius * innerScale - retract) + ")" },
                react_1.default.createElement(Logo, __assign({ width: maxRadius * 2 * innerScale, height: maxRadius * 2 * innerScale, fill: fill, stroke: "none" }, rest))),
            showChildren && (react_1.default.createElement("g", { transform: "translate(" + defaultWidth / 2 + "," + (defaultHeight / 2 + offset + shift - retract) + ")" },
                react_1.default.createElement("text", { textAnchor: "middle", fontSize: 14, fill: contrast }, children)))));
    }
    return (react_1.default.createElement(Logo, __assign({ width: width, height: height, fill: fill, stroke: stroke, title: title }, rest)));
};
exports.default = Adaptiv;
